import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const { kjoretoyUrl } = urler();

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.VarrelaterteSkader,
        tekst: 'Værrelaterte skader',
    },
    {
        id: KategoriSvarId.Feilfylling,
        tekst: 'Feilfylling av drivstoff',
    },
    {
        id: KategoriSvarId.BrannskadeKjoretoy,
        tekst: 'Brannskader på kjøretøy',
    },
    {
        id: KategoriSvarId.TyveriAvNokkel,
        tekst: 'Tyveri av nøkkel',
    },
    {
        id: KategoriSvarId.MistetEllerOdelagtBilnokkel,
        tekst: 'Mistet eller ødelagt nøkkel',
    },
];

export const KjoretoyAndreSkader = () => {
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        switch (svarId) {
            case KategoriSvarId.VarrelaterteSkader:
                navigate(skadeUrlFromSkadetype(Skademeldingstype.VarrelaterteSkader));
                break;
            case KategoriSvarId.Feilfylling:
                navigate(skadeUrlFromSkadetype(Skademeldingstype.Feilfylling));
                break;
            case KategoriSvarId.BrannskadeKjoretoy:
                navigate(skadeUrlFromSkadetype(Skademeldingstype.BrannskadePaKjoretoy));
                break;
            case KategoriSvarId.TyveriAvNokkel:
                navigate(skadeUrlFromSkadetype(Skademeldingstype.TyveriAvNokkel));
                break;
            case KategoriSvarId.MistetEllerOdelagtBilnokkel:
                navigate(skadeUrlFromSkadetype(Skademeldingstype.MistetNokkel));
                break;
            default:
                break;
        }
    };

    return (
        <GruppeLandingsside
            title="Andre skader"
            onNext={onNext}
            navigateToParent={() => navigate(kjoretoyUrl)}
            alternativer={alternativer}
            svgCardType={SvgCardType.BilSkadet}
            kategoriId="kjoretoy-andre-skader"
        />
    );
};
